import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'getLogType' })
export class LogTypePipe implements PipeTransform {

    transform(value: number): string {

        switch ( value ) {
            case 0:
                return 'Edit Member';
            case 1:
                return 'Login As Member';
            case 2:
                return 'Merge Member';

            case 50:
                return 'Edit License';
            case 51:
                return 'Add License As Member';

            case 100:
                return 'Invoice';

            case 150:
                return 'Delete Credit';

            case 800:
                return 'SitePlan Action';
    
            default:
                return 'N/A'
        }

    }

}

